import React, { memo, ReactNode } from "react";

import FormItem from "./components/FormItem";

type Props = {
  isPage?: boolean;
  isFormItem?: boolean;
  children: ReactNode;
};

function Wrapper(props: Props): JSX.Element {
  return props.isFormItem ? <FormItem>{props.children}</FormItem> : <>{props.children}</>;
}

export default memo(Wrapper);
